import React, { Component } from 'react'

// Material UI Imports
import Avatar from '@material-ui/core/Avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import pink from "@material-ui/core/colors/pink";
import orange from "@material-ui/core/colors/orange";

// Material Icons Imports
import IconDevices from '@material-ui/icons/ImportantDevices';

// Assets imports

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';


const orange200 = orange['200'];
const pink400 = pink['400'];

const styles = {
    avatar: {
        size: 30,
        margin: 10,
        color: orange200,
        backgroundColor: pink400,
    },
};

class Device extends Component {

    // constructor(props) {
    //     super(props);

    // };

    render() {
        const { classes } = this.props;
        return (
            <ListItem
            >
                <Avatar
                    className={classes.avatar}
                ><IconDevices /></Avatar>
                <ListItemText primary={this.props.device.identifier}
                    secondary={this.props.device.type}></ListItemText></ListItem>
        );
    }
}

Device.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Device)


// WEBPACK FOOTER //
// src/components/innerComponents/Device.js